@value mobile, tablet from "@shared/styles/breakpoints.module.css";

.list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: var(--space-project-gap);
  margin: 0;
  padding: 0 var(--space-page);
  list-style: none;

  > li {
    display: flex;
    min-width: 0;
    border-bottom: 1px solid var(--color-border);
  }

  > li:last-child,
  > li:nth-last-child(2):nth-child(odd) {
    border-bottom: none;
  }
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-12);
  width: 100%;
  min-width: 0;
  padding: var(--space-catalog-row) 0;
  color: var(--color-text);
  text-decoration: none;
  transition: background var(--motion-fast) var(--motion-ease-out);
}

.number {
  flex: 0 0 var(--layout-catalog-number);
  font-size: var(--type-caption);
  font-variant-numeric: tabular-nums;
  text-align: center;
  color: var(--color-text-muted);
}

.thumb {
  flex: 0 0 var(--layout-catalog-thumb);
  width: var(--layout-catalog-thumb);
  height: var(--layout-catalog-thumb);
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
  background: var(--color-media-surface);
}

/* Контейнер задаёт геометрию поверх базового height:auto в Picture. */
.thumb .image {
  display: block;
  width: 100%;
  height: 100%;
  padding: var(--space-4);
  object-fit: contain;
}

.info {
  flex: 1;
  min-width: 0;
}

.title {
  display: block;
  margin-bottom: var(--space-6);
  font-family: var(--font-heading);
  font-size: var(--type-catalog);
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--color-text-muted);
  font-size: var(--type-caption);
  line-height: 1.55;
}

.arrow {
  display: flex;
  flex: 0 0 var(--layout-catalog-arrow);
  justify-content: center;
  color: var(--color-primary);
  opacity: 0;
  transition: opacity var(--motion-fast) var(--motion-ease-out);

  svg {
    width: var(--space-20);
    height: var(--space-20);
  }
}

.row:focus-visible {
  background: var(--color-card);

  .arrow {
    opacity: 1;
  }
}

@media (hover: hover) and (pointer: fine) {
  .row:hover {
    background: var(--color-card);

    .arrow {
      opacity: 1;
    }
  }
}

/* На сенсорном экране hover нет; место отдаём названию и фото. Ссылка — вся строка. */
@media (hover: none) {
  .arrow {
    display: none;
  }
}

@media (max-width: mobile) {
  .arrow {
    display: none;
  }
}

@media (max-width: tablet) {
  .list {
    grid-template-columns: minmax(0, 1fr);
    padding: 0;

    > li:nth-last-child(2):nth-child(odd) {
      border-bottom: 1px solid var(--color-border);
    }
  }

  .row {
    gap: var(--space-10);
    padding-inline: var(--space-page);
  }
}
